import { Logger } from './logger';
export class DomUtils {
    /**
     * Get element by ID with error handling
     * @param id
     */
    static getElementById(id) {
        const element = jQuery(`#${id}`);
        if (element.length === 0) {
            Logger.warn(`Element with ID '${id}' not found`);
        }
        Logger.debug(`Element with ID '${id}' found`, { element });
        return element;
    }
    /**
     * Show element with optional content
     * @param element
     * @param content
     */
    static showElement(element, content) {
        if (content) {
            element.html(content);
        }
        element.show();
    }
    /**
     * Hide element
     * @param element
     */
    static hideElement(element) {
        element.hide();
    }
    /**
     * Replace element content and show
     * @param element
     * @param content
     */
    static replaceContent(element, content) {
        element.html(content).show();
    }
    /**
     * Find content container using theme-specific selectors
     */
    static findContentContainer() {
        const selectors = [
            '.entry-content',
            '#content .page-content',
            '#tm-main',
        ];
        for (const selector of selectors) {
            const container = jQuery(selector);
            if (container.length > 0) {
                return container;
            }
        }
        Logger.warn('No content container found with standard selectors');
        return jQuery();
    }
    /**
     * Generate container ID for content type
     * @param type
     * @param contentId
     */
    static getContainerId(type, contentId) {
        return `gpsa-${type}-${contentId}`;
    }
    /**
     * Generate loading container ID
     * @param type
     * @param contentId
     */
    static getLoadingContainerId(type, contentId) {
        return `gpsa-${type}-loading-${contentId}`;
    }
    /**
     * Generate form container ID
     * @param contentId
     */
    static getFormContainerId(contentId) {
        return `gpsa-form-content-${contentId}`;
    }
}
